import { container } from "tsyringe";
export class UseCaseGetOffers {
    constructor() {
        this.handle = async (requestBody) => {
            return this._getOffers.handle(requestBody);
        };
        this._getOffers = container.resolve("iUseCaseGetOffers");
    }
}
